import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCustomerServiceManagementSlaRoute: InvariantJiraRoute = {
	name: 'project-settings-customer-service-management-sla',
	path: '/jira/customer-service-management/projects/:projectKey/settings/sla/(custom|new)?/:id?/(edit)?',
};
